<nz-divider [nzText]="travelers" nzOrientation="center">
  <ng-template #travelers>
    <h5>{{ 'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT' | translate }}</h5>
  </ng-template>
</nz-divider>

<div class="row">
  @if (controls.travelDocumentType; as travelDocumentType) {
    <div class="standard-form-field widened-field travelDocumentType-field required-field">
      <label id="travelDocumentTypeLabel" [class.invalid]="travelDocumentType.touched && travelDocumentType.invalid">
        {{ 'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT_TYPE.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <mat-select
          id="travelDocumentType"
          panelClass="standard-select travel-document-type-select-panel"
          [placeholder]="'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT_TYPE.PLACEHOLDER' | translate"
          [formControl]="travelDocumentType"
          [required]="true"
          [attr.aria-labelledby]="'travelDocumentTypeLabel'"
          [attr.aria-required]="true"
          [attr.aria-invalid]="travelDocumentType.touched && travelDocumentType.invalid ? 'true' : null"
          [attr.aria-describedby]="
            travelDocumentType.touched && travelDocumentType.invalid ? 'applicantTravelDocumentTypeError' : null
          ">
          <mat-option class="travel-document-primary-option" [value]="primaryTravelDocumentType">
            <span class="travel-document-primary-label">
              {{ 'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT_TYPE.PASSPORT_OPTION' | translate }}
            </span>
          </mat-option>
          <mat-optgroup
            class="travel-document-other-group"
            [label]="'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT_TYPE.OTHER_GROUP_LABEL' | translate">
            @for (item of otherTravelDocumentTypes; track item) {
              <mat-option class="travel-document-other-option" [value]="item">
                {{ 'COMMON.TRAVEL_DOCUMENT_TYPES.' + item | translate }}
              </mat-option>
            }
          </mat-optgroup>
        </mat-select>
        @if (travelDocumentType.touched && travelDocumentType.invalid) {
          <mat-error id="applicantTravelDocumentTypeError">
            {{ travelDocumentType.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.travelDocumentCountryOfOrigin; as travelDocumentCountryOfOrigin) {
    <div class="standard-form-field widened-field travelDocumentCountryOfOrigin-field required-field">
      <app-country-select
        class="country-select"
        [fieldControl]="travelDocumentCountryOfOrigin"
        [fieldKey]="'travelDocumentCountryOfOrigin'"
        [isRequired]="true"
        [fieldLabelKey]="'TRAVEL_DOCUMENT_COUNTRY_OF_ORIGIN'">
      </app-country-select>
    </div>
  }
</div>
<div class="row">
  @if (controls.travelDocumentSeries; as travelDocumentSeries) {
    <div class="standard-form-field travelDocumentSeries-field required-field">
      <label
        for="travelDocumentSeriesInput"
        [class.invalid]="travelDocumentSeries.touched && travelDocumentSeries.invalid">
        {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-SERIES.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          id="travelDocumentSeriesInput"
          [placeholder]="'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-SERIES.PLACEHOLDER' | translate"
          matInput
          type="text"
          maxLength="100"
          [required]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="travelDocumentSeries.touched && travelDocumentSeries.invalid ? 'true' : null"
          [attr.aria-describedby]="
            travelDocumentSeries.touched && travelDocumentSeries.invalid ? 'applicantTravelDocumentSeriesError' : null
          "
          [formControl]="travelDocumentSeries" />
        @if (travelDocumentSeries.touched && travelDocumentSeries.invalid) {
          <mat-error id="applicantTravelDocumentSeriesError">
            {{ travelDocumentSeries.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.travelDocumentNumber; as travelDocumentNumber) {
    <div class="standard-form-field travelDocumentNumber-field required-field">
      <label
        for="travelDocumentNumberInput"
        [class.invalid]="travelDocumentNumber.touched && travelDocumentNumber.invalid">
        {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NUMBER.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          id="travelDocumentNumberInput"
          [placeholder]="'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NUMBER.PLACEHOLDER' | translate"
          matInput
          type="text"
          maxLength="100"
          [required]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="travelDocumentNumber.touched && travelDocumentNumber.invalid ? 'true' : null"
          [attr.aria-describedby]="
            travelDocumentNumber.touched && travelDocumentNumber.invalid ? 'applicantTravelDocumentNumberError' : null
          "
          [formControl]="travelDocumentNumber" />
        @if (travelDocumentNumber.touched && travelDocumentNumber.invalid) {
          <mat-error id="applicantTravelDocumentNumberError">
            {{ travelDocumentNumber.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.travelDocumentNrOfPersonsEntered; as travelDocumentNrOfPersonsEntered) {
    <div class="standard-form-field widened-field travelDocumentNrOfPersonsEntered-field required-field">
      <label
        for="travelDocumentNrOfPersonsEnteredInput"
        [class.invalid]="travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid">
        {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NR-OF-PERSONS-ENTERED.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          id="travelDocumentNrOfPersonsEnteredInput"
          [placeholder]="'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NR-OF-PERSONS-ENTERED.PLACEHOLDER' | translate"
          matInput
          type="number"
          min="0"
          max="20"
          [required]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="
            travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid ? 'true' : null
          "
          [attr.aria-describedby]="
            travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid
              ? 'applicantTravelDocumentNrOfPersonsEnteredError'
              : null
          "
          [formControl]="travelDocumentNrOfPersonsEntered" />
        @if (travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid) {
          <mat-error id="applicantTravelDocumentNrOfPersonsEnteredError">
            {{ travelDocumentNrOfPersonsEntered.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
</div>
<div class="row">
  @if (controls.travelDocumentIssueDate; as travelDocumentIssueDate) {
    <div class="standard-form-field travelDocumentIssueDate-field required-field">
      <label
        for="travelDocumentIssueDateInput"
        [class.invalid]="travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid">
        {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUE-DATE.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline" (click)="travelDocumentIssueDatePicker.open()">
        <input
          id="travelDocumentIssueDateInput"
          [placeholder]="'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUE-DATE.PLACEHOLDER' | translate"
          matInput
          (focus)="travelDocumentIssueDatePicker.open()"
          #applicantIssueDate
          [matDatepicker]="travelDocumentIssueDatePicker"
          [min]="minValidDateInThePast"
          [max]="maxValidDateInThePast"
          [required]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid ? 'true' : null"
          [attr.aria-describedby]="
            travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid
              ? 'applicantTravelDocumentIssueDateError'
              : null
          "
          [readonly]="true"
          [formControl]="travelDocumentIssueDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="travelDocumentIssueDatePicker"
          aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
        </mat-datepicker-toggle>
        <mat-datepicker
          #travelDocumentIssueDatePicker
          [startView]="'month'"
          [startAt]="travelDocumentIssueDate.value || documentIssuePickerStartDate"
          (closed)="applicantIssueDate.blur()">
        </mat-datepicker>
        @if (travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid) {
          <mat-error id="applicantTravelDocumentIssueDateError">
            {{ travelDocumentIssueDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.travelDocumentExpiryDate; as travelDocumentExpiryDate) {
    <div class="standard-form-field travelDocumentExpiryDate-field required-field">
      <label
        for="travelDocumentExpiryDateInput"
        [class.invalid]="travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid">
        {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-EXPIRY-DATE.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline" (click)="travelDocumentExpiryDatePicker.open()">
        <input
          id="travelDocumentExpiryDateInput"
          [placeholder]="'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-EXPIRY-DATE.PLACEHOLDER' | translate"
          matInput
          (focus)="travelDocumentExpiryDatePicker.open()"
          #applicantExpiryDate
          [matDatepicker]="travelDocumentExpiryDatePicker"
          [min]="minValidDateInTheFuture"
          [max]="maxValidDateInTheFuture"
          [required]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid ? 'true' : null"
          [attr.aria-describedby]="
            travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid
              ? 'applicantTravelDocumentExpiryDateError'
              : null
          "
          [readonly]="true"
          [formControl]="travelDocumentExpiryDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="travelDocumentExpiryDatePicker"
          aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
        </mat-datepicker-toggle>
        <mat-datepicker
          #travelDocumentExpiryDatePicker
          [startView]="'month'"
          [startAt]="travelDocumentExpiryDate.value || documentExpiryPickerStartDate"
          (closed)="applicantExpiryDate.blur()">
        </mat-datepicker>
        @if (travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid) {
          <mat-error id="applicantTravelDocumentExpiryDateError">
            {{ travelDocumentExpiryDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  @if (controls.travelDocumentIssuingAuthority; as travelDocumentIssuingAuthority) {
    <div class="standard-form-field widened-field travelDocumentIssuingAuthority-field required-field">
      <label
        for="travelDocumentIssuingAuthorityInput"
        [class.invalid]="travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid">
        {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUING-AUTHORITY.MAIN-LABEL' | translate }}
        <span aria-hidden="true">&nbsp;*</span>
        <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
      </label>
      <mat-form-field appearance="outline">
        <input
          id="travelDocumentIssuingAuthorityInput"
          [placeholder]="'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUING-AUTHORITY.PLACEHOLDER' | translate"
          matInput
          type="text"
          maxLength="100"
          [required]="true"
          [attr.aria-required]="true"
          [attr.aria-invalid]="
            travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid ? 'true' : null
          "
          [attr.aria-describedby]="
            travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid
              ? 'applicantTravelDocumentIssuingAuthorityError'
              : null
          "
          [formControl]="travelDocumentIssuingAuthority"
          (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()" />
        @if (travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid) {
          <mat-error id="applicantTravelDocumentIssuingAuthorityError">
            {{ travelDocumentIssuingAuthority.errors | errorsFormatingAndTranslate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
</div>
